export default __webpack_public_path__ + "static/media/manage-users.38cda339.svg";